<!--
 * @auth: lidd
 -->
<template>
  <div class="sy-accessory-img font-color-primary"
  :class="{
    'sy-accessory-img_hover' : !$attrs.disabled,
    'sy-accessory-img_mini' : miniMode,
    'sy-accessory-img_mini-show-more' : showMoreFlag
  }">
    <sy-upload
      v-bind="$attrs"
      v-on="$listeners"
      listType="picture-card"
      acceptType="IMAGE"
      :on-preview="handlePreview"
    >
      <i class="el-icon-plus sy-accessory-img-trigger-plus"></i>
    </sy-upload>
    <div v-if="miniMode && $attrs.fileList.length > 2 && !showMoreFlag" class="font-color-link sy-accessory-img_mini-load-more">
      <span @click="showMoreFlag = true">共{{$attrs.fileList.length}}张</span><i class="el-icon-arrow-down"></i>
    </div>
    <el-dialog append-to-body :title="pageText.picturePreview" :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
  import SyUpload from '../sy-upload/upload'

  export default {
    props: {
      pageText: {
        type: Object,
        default: () => ({})
      },
      miniMode: Boolean
    },
    data () {
      return {
        dialogVisible: false,
        dialogImageUrl: '',
        showMoreFlag: false
      }
    },
    components: {
      SyUpload
    },
    methods: {
      // 预览已上传图片
      handlePreview (file) {
        if (this.$attrs['on-preview']) {
          this.$attrs['on-preview'](file)
          return
        }

        this.dialogImageUrl = file.url
        this.dialogVisible = true
      }
    }
  }
</script>

<style lang="scss" scoped>
.sy-accessory-img {
  font-size: 0px;
  ::v-deep .sy-upload--picture-card {
    width: 62px;
    height: 62px;
    line-height: 62px;
  }
  .sy-accessory-img-trigger-plus {
    line-height: 62px;
  }
}
.sy-accessory-img_hover {
  ::v-deep .sy-upload--picture-card:hover {
    border-color: currentColor;
    .el-icon-plus {
      color: currentColor;
    }
  }
}

.sy-accessory-img_mini {
  height: 78px;
  // 从对象 最小宽度 再小没办法展示第一张图片 会导致显示更多逻辑有问题
  min-width: 210px;
  overflow: hidden;
  position: relative;
  ::v-deep .sy-upload--picture-card {
    margin-bottom: 16px;
  }
  .sy-accessory-img_mini-load-more {
    position: absolute;
    left: 0;
    bottom: 0;
    font-size: 12px;
    letter-spacing: 0;
    line-height: 16px;
    font-weight: 400;
  }
}
.sy-accessory-img_mini-show-more {
  height: initial;
  ::v-deep .sy-upload--picture-card {
    margin-bottom: 0px;
  }
}
</style>
